import { QueryFactory } from "../../../../Common";
export const QGetEventsByLeagueId = QueryFactory("GetEventsByLeagueId");
//# sourceMappingURL=QGetEventsByLeagueId.js.map